export const desktopMenu = () => {
  // check if desktop screen size
  const checkDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

  // open sub-menu on hover
  const $parentItems = $(
    '.site-navigation a[href="#services"], .site-navigation a[href="#surgery"], .site-navigation a[href="#resources"]',
  );
  const $superparentItems = $(
    '.supermenu a[href="#services"], .supermenu a[href="#surgery"], .supermenu a[href="#resources"]',
  );
  const supermenu = document.querySelector('.supermenu');
  const $supermenu = $(supermenu);

  $parentItems.on('click', function (e) {
    e.preventDefault();
    if (!checkDesktop()) return;

    const href = this.getAttribute('href');

    $supermenu.addClass('is-active');

    // animate super menu in
    supermenu.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 150,
    });

    // menu item
    $(`.supermenu a[href="${href}"]`).parent().addClass('is-active');
    // menu
    $(`${href}-menu`).addClass('is-active');
  });

  $superparentItems.on('click', function (e) {
    e.preventDefault();
    if (!checkDesktop()) return;

    const href = this.getAttribute('href');

    $supermenu.addClass('is-active');
    // menu items
    $(`.supermenu .menu-item`).removeClass('is-active');
    $(this).parent().addClass('is-active');
    // menus
    $('.supermenu .menu-wrapper').removeClass('is-active');
    $(`${href}-menu`).addClass('is-active');
  });

  // on click outside of menu, close menu
  const closeMenu = async () => {
    $('.menu-toggle').removeClass('is-active');
    $('#masthead').removeClass('is-active');

    // animmate super menu out
    await supermenu.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 150,
    }).finished;

    $supermenu.removeClass('is-active');
    $('.supermenu .menu-item').removeClass('is-active');
    $('.supermenu .menu-wrapper').removeClass('is-active');
  };

  $(document).on('click', function (e) {
    if (
      !$(e.target).closest('.site-navigation').length &&
      !$(e.target).closest('.supermenu').length
    ) {
      closeMenu();
    }
  });
  // on escape close menu
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      closeMenu();
    }
  });
};
